import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/ibm-aiops-training/ibm-aiops-training/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Accordion = makeShortcode("Accordion");
const AccordionItem = makeShortcode("AccordionItem");
const InlineNotification = makeShortcode("InlineNotification");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`🚀 TASK: Install the IBM Catalog source`}</h2>
    <a href="https://www.ibm.com/docs/en/cloud-paks/cloud-pak-aiops/4.6.0?topic=aiops-starter-installation" target="_blank">🌏 Documentation for the Task: Online starter installation of CP4AIOPS</a>
    <p>{`Add the CP4AIOPS `}<inlineCode parentName="p">{`CatalogSource`}</inlineCode>{` to your OpenShift cluster as described in the Documentation.`}</p>
    <Accordion mdxType="Accordion">
      <AccordionItem title="💡 Solution?" mdxType="AccordionItem">
        <ol>
          <li parentName="ol">
            <p parentName="li">{`Run the following command to create the `}<inlineCode parentName="p">{`CatalogSource`}</inlineCode>{`.`}</p>
            <pre parentName="li"><code parentName="pre" {...{
                "className": "language-yaml"
              }}>{`cat << EOF | oc apply -f -
apiVersion: operators.coreos.com/v1alpha1
kind: CatalogSource
metadata:
  name: ibm-operator-catalog
  namespace: openshift-marketplace
spec:
  displayName: ibm-operator-catalog
  publisher: IBM Content
  sourceType: grpc
  image: icr.io/cpopen/ibm-operator-catalog:latest
EOF
`}</code></pre>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Update the `}<inlineCode parentName="p">{`CatalogSource`}</inlineCode>{` to always use the current image digest by running the following commands:`}</p>
            <pre parentName="li"><code parentName="pre" {...{
                "className": "language-bash"
              }}>{`IMGDIGEST=\`oc get pods -n openshift-marketplace -l=olm.catalogSource=ibm-operator-catalog --no-headers -o=jsonpath="{.items[0].status.containerStatuses[0].imageID}" -n openshift-marketplace\` && \\
oc patch catalogsource ibm-operator-catalog -n openshift-marketplace --type=json -p "[{ "op": "test", "path": "/spec/image", "value": "\\"icr.io/cpopen/ibm-operator-catalog:latest\\"" }, { "op": "replace", "path": "/spec/image", "value": "\\"$IMGDIGEST\\"" }]"
`}</code></pre>
          </li>
        </ol>
        <blockquote>
          <p parentName="blockquote">{`This creates the `}<inlineCode parentName="p">{`CatalogSource`}</inlineCode>{` that provides the available IBM Operators (not just CP4AIOPS). `}</p>
        </blockquote>
      </AccordionItem>
    </Accordion>
    <InlineNotification kind="info" mdxType="InlineNotification">
      <p>{`The IBM Operator Catalog also contains the catalogs for other IBM Cloud Paks®. If multiple IBM Cloud Paks are installed on your cluster, then the polling attribute is configured for all of them.`}</p>
      <p>{`You can go to Operators/OperatorHub in your Openshift Web Console to check out the available Operators .`}</p>
    </InlineNotification>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      